export interface Country {
  code: string;
  name: string;
}

export const COUNTRIES: Country[] = [
  { code: "US", name: "United States" },
  { code: "BR", name: "Brazil" },
  { code: "GB", name: "United Kingdom" },
  { code: "JP", name: "Japan" },
  { code: "KR", name: "South Korea" },
  { code: "CN", name: "China" },
  { code: "RU", name: "Russia" },
  { code: "DE", name: "Germany" },
  { code: "FR", name: "France" },
  { code: "IT", name: "Italy" },
  { code: "ES", name: "Spain" },
  { code: "CA", name: "Canada" },
  { code: "AU", name: "Australia" },
  { code: "IN", name: "India" },
  { code: "ID", name: "Indonesia" },
  { code: "PH", name: "Philippines" },
  { code: "VN", name: "Vietnam" },
  { code: "TH", name: "Thailand" },
  { code: "MY", name: "Malaysia" },
  { code: "SG", name: "Singapore" },
  { code: "MX", name: "Mexico" },
  { code: "AR", name: "Argentina" },
  { code: "CL", name: "Chile" },
  { code: "CO", name: "Colombia" },
  { code: "PE", name: "Peru" },
  { code: "TR", name: "Turkey" },
  { code: "SA", name: "Saudi Arabia" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "ZA", name: "South Africa" },
  { code: "EG", name: "Egypt" },
  { code: "UA", name: "Ukraine" },
  { code: "PL", name: "Poland" },
  { code: "NL", name: "Netherlands" },
  { code: "SE", name: "Sweden" },
  { code: "NO", name: "Norway" },
  { code: "DK", name: "Denmark" },
  { code: "FI", name: "Finland" },
  { code: "PT", name: "Portugal" },
];

export const getCountryName = (code: string): string => {
  return COUNTRIES.find((c) => c.code === code)?.name || code;
};

export const getCountryByLanguageCode = (languageCode: string): string | null => {
  if (!languageCode) return null;
  
  const normalized = languageCode.toLowerCase().replace('_', '-');
  
  // Direct mapping for common locales
  const map: Record<string, string> = {
    'en-us': 'US',
    'en-gb': 'GB',
    'pt-br': 'BR',
    'pt-pt': 'PT',
    'es-es': 'ES',
    'es-mx': 'MX',
    'ja-jp': 'JP',
    'ko-kr': 'KR',
    'zh-cn': 'CN',
    'ru-ru': 'RU',
    'fr-fr': 'FR',
    'de-de': 'DE',
    'it-it': 'IT',
  };

  if (map[normalized]) return map[normalized];

  // Try to split by dash and take the second part as country code if it's valid
  const parts = normalized.split('-');
  if (parts.length === 2) {
    const countryCode = parts[1].toUpperCase();
    if (COUNTRIES.some(c => c.code === countryCode)) {
      return countryCode;
    }
  }

  return null;
};

